import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useState, useMemo } from 'react'

import BarcodeGenerator from '@components/Barcode/index'
import {
	fetchSalesOrderWithDocEntry,
	fetchSeriesBarcode,
} from '@utils/fetchData'

const SeriesBarcodePage = () => {
	const [docEntry, setDocEntry] = useState('')

	useEffect(() => {
		const docEntrySeries = localStorage.getItem('seriesDocEntry')

		if (docEntrySeries) {
			setDocEntry(JSON.parse(docEntrySeries))
		}
	}, [])

	const { data = [] } = useQuery({
		queryKey: ['seriesBarcode', docEntry],
		queryFn: fetchSeriesBarcode,
		enabled: !!docEntry,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (data.length > 0) {
			setTimeout(() => {
				window.print()
				console.log('data', data)
			}, 500)
		}
	}, [data])

	const uniqueData = useMemo(() => {
		const seen = new Set()
		return data.filter((line) => {
			if (seen.has(line.serialNumber)) return false
			seen.add(line.serialNumber)
			return true
		})
	}, [data])
	const capitalize = (s = "") =>
  s ? s[0].toUpperCase() + s.slice(1)?.toLowerCase() : "";

	return (
		<>
			<style>
				{`
				body {
					margin: 0;
					padding: 0;
					background: white;
					color: black;
					font-family: sans-serif;
				}

				.print-container {
					width: 80mm;
				}

				.label {
					width: 80mm;
					height: 50mm;
					padding: 2mm;
					box-sizing: border-box;
				}

				.label-content {
					display: flex;
					flex-direction: column;
				}

				.creator {
					font-weight: 800;
					font-size: 18px;
				}

				.doc {
					font-weight: 800;
					font-size: 18px;
				}

				.item-name {
					font-size: 18px;
				}

				.size {
					font-weight: 800;
				font-size: 18px;

				}

				.bold {
					font-weight: 800;
				}

				.row {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.date,
				.serial {
					display: flex;
					gap: 1px;
					align-items: center;
					font-size: 18px;
				}

				.barcode {
					margin-top: 6px;
					width: 100%;
				}

				@media print {

					@page {
						size: 80mm 50mm;
						margin: 0;
					}

					html, body {
						width: 80mm;
						height: auto;
						margin: 0;
						padding: 0;
					}

					.page-break {
						page-break-after: always;
					}

					.page-break:last-child {
						page-break-after: auto;
					}

					svg {
						width: 100%;
						height: auto;
					}
				}
				`}
			</style>

			<div className="print-container">
				{uniqueData.map((item) => (
					<div
						key={`${item.docNum}-${item.serialNumber}`}
						className="label page-break"
					>
						<div className="label-content">
							<span className="creator">{item?.cardName}</span>

							<div className="row">
								<span className="doc">
									{item.salesOrderDocNumPrefix}
								</span>

								<div className="date">
									<span>Дата:</span>
									<span className="bold">{item.dueDate}</span>
								</div>
							</div>

							<span className="item-name">{capitalize(item.itemName)}</span>
<div>
		<span className="serial">
									<span>Деталь:</span>
									<span className="bold">
										{item.serialNumber}
									</span>
								</span>
							<div className="row">
								<span className="size">
									{item.width
										? `${item.width} x ${item.hight}`
										: ''}
								</span>


							</div>
</div>


							<BarcodeGenerator
								docNum={item.serialNumber}
								displayValue={false}
								width={2}
								height={25}
								margin={0}
								fontSize={'10'}
								className="barcode"
							/>
						</div>
					</div>
				))}
			</div>
		</>
	)
}

export default SeriesBarcodePage
